import { AutogenLayoutBackOfficeCommentsTable } from "./autogen/AutogenLayoutBackOfficeCommentsTable";
import {
    DataSourceMode, PrintableEvent, TableRow, TableRowDisplayEvent, TableRowMode, Textbox
} from "@mcleod/components";

export class BackOfficeCommentsTable extends AutogenLayoutBackOfficeCommentsTable {
    tableCommentsOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.target as TableRow;
        const textboxUnits = tableRow.findComponentById("textboxUnits") as Textbox;
        if (textboxUnits != null) {
            textboxUnits.nullDisplayValue = DataSourceMode.SEARCH ? "" : "1";
        }
        if (TableRowMode.QUICK_ADD === tableRow.mode) {
            const labelEnteredDate = tableRow.findComponentById("labelEnteredDate");
            if (labelEnteredDate != null) {
                labelEnteredDate.visible = false;
            }
            const textboxEnteredUserId = tableRow.findComponentById("textboxEnteredUserId") as Textbox;
            if (textboxEnteredUserId != null) {
                textboxEnteredUserId.visible = false;
            }
        }
    }

    textboxEnteredUserIdOnPrintable(event: PrintableEvent) {
        const textbox = event.target as Textbox;
        textbox.printable = true;
    }
}
